import { Component } from "react";
import { QESCheckbox } from "./qes-standards";

interface CheckItemProps {
  checked: boolean;
  disabled?: boolean;
  indeterminate: boolean;
  id?: string;
  name?: string;

  onChecked?: () => void;
  onUnchecked?: () => void;
}

export default class CheckItem extends Component<CheckItemProps> {

  // Don't re-render if the event handlers change.
  public shouldComponentUpdate(nextProps: CheckItemProps) {
    return nextProps.checked !== this.props.checked ||
      nextProps.indeterminate !== this.props.indeterminate ||
      nextProps.name !== this.props.name ||
      nextProps.disabled !== this.props.disabled;
  }

  public render() {
    return (
      <QESCheckbox
        label={this.props.name}
        indeterminate={this.props.indeterminate}
        checked={this.props.checked}
        disabled={this.props.disabled}
        id={this.props.id}
        onChange={this.handleChange}
        onLabelClick={(e) => this.handleChange(e, true)}
        testId={this.props.name ? ("check-item__" + this.props.name.replace(",", "-").split(" ").join("") + "-checkbox") : null}
      />
    );
  }

  private handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.MouseEvent, isLabel?: boolean) => {
    e.stopPropagation();

    // if the label was clicked, we need to have it get info from the checkbox instead
    let checkbox = e.target as HTMLInputElement;
    if (isLabel) {
      checkbox = checkbox.parentNode.querySelector(`#${checkbox.getAttribute("for")}`) as HTMLInputElement;
    }

    // If it's now checked, or it was indeterminate, trigger a "check" event from the outside.
    if (checkbox?.checked || this.props.indeterminate) {
      if (this.props.onChecked) {
        this.props.onChecked();
      }
    } else {
      if (this.props.onUnchecked) {
        this.props.onUnchecked();
      }
    }
  }
}
